// Zaehlt laufende Warenkorb-Requests - auch die von Apps. Wird von
// goToCheckout gelesen, um ohne eigene Abfragen zu erkennen, wann der
// Warenkorb zur Ruhe gekommen ist.
(function () {
  if (window.__ppCartWatch) return;
  var w = (window.__ppCartWatch = { active: 0, lastEnd: 0 });
  // Nur schreibende Zugriffe zaehlen. Cart-Drawer-Apps lesen /cart.js im
  // Sekundentakt - darauf zu warten heisst, nie fertig zu werden. Fuer die
  // Vollstaendigkeit des Warenkorbs zaehlt allein, wer ihn veraendert.
  var isCart = function (url) { return /\/cart\/(add|change|update|clear)/.test(String(url)); };
  var done = function () { w.active--; w.lastEnd = Date.now(); };

  var realFetch = window.fetch;
  if (realFetch) {
    window.fetch = function (input) {
      if (!isCart((input && input.url) || input)) return realFetch.apply(this, arguments);
      w.active++;
      return realFetch.apply(this, arguments).then(
        function (r) { done(); return r; },
        function (e) { done(); throw e; }
      );
    };
  }

  // Manche Apps nutzen XMLHttpRequest statt fetch.
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ppCart = isCart(url);
    return open.apply(this, arguments);
  };
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__ppCart) {
      w.active++;
      this.addEventListener('loadend', done, { once: true });
    }
    return send.apply(this, arguments);
  };
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      var formData = new FormData(this.form);
      // Asking for the cart drawer sections makes Shopify render them server
      // side, which costs real time. When we leave for the checkout right after
      // this, nobody ever sees them - so don't ask.
      if (this.cart && !this.skipCart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            this.goToCheckout();
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Beim Skip-Cart wird noch auf den Warenkorb gewartet - Button bleibt
          // im Ladezustand, sonst kann hier ein zweites Mal geklickt werden.
          if (this.redirecting) return;
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Apps wie Kaching Bundles legen nach dem eigenen /cart/add noch eigene
    // Zeilen nach. Wer sofort weiterleitet, landet mit halbem Warenkorb im
    // Checkout. Frueher wurde dafuer /cart.js gepollt - das war der Fehler:
    // Shopify serialisiert Warenkorb-Zugriffe, jede eigene Abfrage stellt sich
    // also vor die Requests der App und verlangsamt genau das, worauf gewartet
    // wird (gemessen: /cart.js bis 1400ms statt 80ms). Jetzt wird nur noch
    // beobachtet, wann die App fertig ist - ohne einen einzigen Request.
    goToCheckout() {
      this.redirecting = true;

      const root = (window.routes && window.routes.root_url) || '/';
      const base = root === '/' ? '' : root.replace(/\/$/, '');
      const checkoutUrl = base + '/checkout';

      const watch = window.__ppCartWatch;
      const go = () => { window.location = checkoutUrl; };
      if (!watch) return go();

      const started = Date.now();
      const QUIET = 120;      // so lange darf kein Schreibzugriff mehr laufen
      const MAX_WAIT = 5000;  // Notbremse; Kachings Nachlage dauert real ~1,6s

      const check = () => {
        const idle = watch.active === 0 && Date.now() - watch.lastEnd >= QUIET;
        if (idle || Date.now() - started > MAX_WAIT) return go();
        setTimeout(check, 40);
      };
      check();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
